import React, { Component } from 'react'
import PagesRenderer from '@rwitl/screen-renderer/lib/PagesRenderer'
import Page from './Page'
import createEventSync from './lib/createEventSync'

class CustomPagesRenderer extends Component {



  onDropMultiEvents = (...args) => {
    // We only care if one drop was successful
    var successDropEvents = args.find(args => args[0] == true)
    if (successDropEvents)
      return this.props.onDrop(...successDropEvents)
    return this.props.onDrop(false)
  }

  render = () => {

    const {
      screenState,
      renderedPages,
      componentMap,
      deleteChildScreen,
      extraFieldProps,
      getChildScreenSchema,
      nestedLayout,
      onControlUpdate,
      onLoadChildScreen,
      readOnly,
      onStateChange,
      getScreenState,
      SideControl,
      dragging,
    } = this.props

    // This allows us to group the many page onDrop handlers together
    // into one onDrop handler so we can do multi page transfer of controls
    // TODO: Potential memory leak?
    var createEventHandler = createEventSync(this.onDropMultiEvents)


    return <div>
      {renderedPages.map(pageKey => <Page
        key={pageKey}
        pageKey={pageKey}
        renderedForms={screenState[pageKey]['layout']}
        screenState={screenState}
        componentMap={componentMap}
        deleteChildScreen={deleteChildScreen}
        extraFieldProps={extraFieldProps}
        getChildScreenSchema={getChildScreenSchema}
        nestedLayout={nestedLayout}
        onControlUpdate={onControlUpdate}
        onLoadChildScreen={onLoadChildScreen}
        readOnly={readOnly}
        onStateChange={onStateChange}
        getScreenState={getScreenState}
        SideControl={SideControl}
        dragging={dragging}
        onDrop={createEventHandler()}
      />)}
    </div>
  }
}

export default CustomPagesRenderer





// WEBPACK FOOTER //
// ./src/modules/BranchEditor/ProductEditor/ScreenRenderer/PagesRenderer.js